'use client';

import React from 'react';
import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';

const CategoryDeclaration = () => {
  return (
    <section className="relative bg-white py-32 lg:py-48">
      <div className="absolute inset-0 bg-[linear-gradient(rgba(10,37,64,0.03)_1px,transparent_1px),linear-gradient(90deg,rgba(10,37,64,0.03)_1px,transparent_1px)] bg-[size:80px_80px]"></div>
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-5xl mx-auto">
          <div className="text-center space-y-12">
            <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold font-headline text-[#0A2540] leading-tight tracking-tight">
              Defining the Standard for
              <span className="block mt-4 text-orange-600">AI Leadership Maturity</span>
            </h1>
            
            <div className="max-w-3xl mx-auto">
              <p className="text-xl md:text-2xl text-gray-700 font-body leading-relaxed">
                AI Change Leaders is an independent custodian of best practice in organisational AI leadership and adoption. We define what good looks like, assess organisations against clear standards, and recognise those that demonstrate maturity through evidence—not promises.
              </p>
            </div>

            <div className="pt-8 flex flex-col sm:flex-row items-center justify-center gap-4">
              <Link
                href="/ai-change-leadership-pillar-page"
                className="inline-flex items-center gap-2 px-8 py-4 border-2 border-[#0A2540] text-[#0A2540] font-semibold font-body text-lg rounded-none hover:bg-[#0A2540] hover:text-white transition-all duration-300"
              >
                Explore the Standard
                <Icon name="ArrowRightIcon" size={20} variant="outline" />
              </Link>
              <Link
                href="#engagement"
                className="inline-flex items-center gap-2 px-8 py-4 bg-[#0A2540] text-white font-semibold font-body text-lg rounded-none hover:bg-[#0D2F52] transition-all duration-300"
              >
                Start Diagnostic
                <Icon name="ArrowDownIcon" size={20} variant="solid" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CategoryDeclaration;